import axios from 'axios'
import { Message, Loading } from 'element-ui'
// import config from './config.js'
import store from '@/store'
import { getCoreToken, getToken } from '@/utils/auth'
import _ from 'lodash';
import qs from 'qs'

//loading对象
let loading;

//当前正在请求的数量
let needLoadingRequestCount = 0;

//显示loading
function showLoading (target) {
  // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
  // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
  if (needLoadingRequestCount === 0 && !loading) {
    loading = Loading.service({
      lock: true,
      text: "Loading...",
      background: 'rgba(255, 255, 255, 0.5)',
      target: target || "body"
    });
  }
  needLoadingRequestCount++;
}

//隐藏loading
function hideLoading () {
  needLoadingRequestCount--;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); //做个保护
  if (needLoadingRequestCount === 0) {
    //关闭loading
    toHideLoading();
  }
}

//防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
var toHideLoading = _.debounce(() => {
  loading ? loading.close() : '';
  loading = null;
}, 300);

export default function $axios (options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: process.env[`VUE_APP_${options.base}_API`],
      headers: {},
      contentType: 'application/json;charset=UTF-8',
      withCredentials: false, // 跨域请求时发送 cookies
      transformResponse: [function (data) { }],
      timeout: 60000 // request timeout
    })
    // request 拦截器
    instance.interceptors.request.use(
      config => {
        // Tip: 1
        // 请求开始的时候可以结合 vuex 开启全屏的 loading 动画

        // Tip: 2
        // 带上 token , 可以结合 vuex 或者重 localStorage
        // if (store.getters.token) {
        //     config.headers['X-Token'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
        // } else {
        //     // 重定向到登录页面
        // }

        // Tip: 3
        // 根据请求方法，序列化传来的参数，根据后端需求是否序列化
        // if (config.method.toLocaleLowerCase() === 'post' || config.method.toLocaleLowerCase() === 'put' || config.method.toLocaleLowerCase() === 'delete') {
        //   // config.data = qs.stringify(config.data)
        // }
        if (options.loading) {
          showLoading()
          // setTimeout(() => {
          //   hideLoading()
          // }, 5000)
        }
        if (!config.json) {
          config.data = qs.stringify(config.data)
        }
        if (config.base === 'CORE') {
          config.headers['userAuthorization'] = getCoreToken()
        } else if (config.base === 'TEST') {
          config.headers['userAuthorization'] = config.userAuthorization
        } else if (getToken()) {
          config.headers['token'] = getToken()
        }
        return config
      },
      error => {
        // 请求错误时做些事(接口错误、超时等)
        // Tip: 4
        // 关闭loadding
        if (options.loading) {
          hideLoading();
        }
        console.log('request:', error)
        //  1.判断请求超时
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
          console.log('根据你设置的timeout/真的请求超时 判断请求现在超时了，你可以在这里加入超时的处理方案')
          // return service.request(originalRequest);//例如再重复请求一次
        }
        //  2.需要重定向到错误页面
        const errorInfo = error.response

        // if (errorInfo) {
        //   // error =errorInfo.data//页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
        //   const errorStatus = errorInfo.status // 404 403 500 ... 等
        //   router.push({
        //     path: `/error/${errorStatus}`
        //   })
        // }
        return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    )

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        // 关闭loadding
        if (options.loading) {
          hideLoading()
        }


        let data
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        if (response.data === undefined) {
          data = response.request.responseText
        } else {
          data = response.data
        }
        // 根据返回的code值来做不同的处理（和后端约定）
        data = JSON.parse(data)
        data.code = Number(data.code)
        if (data.code === 200) {
          return data
        } else if (data.code === 1001) {
          return data
        } else if (data.code === 500 && data.msg.includes('重新登陆')) {
          store.dispatch('user/logout')
        } else {
          if (options.loading) {
            hideLoading()
          }
          if (!options.hideMsg) {
            Message({
              message: data.message || data.msg || '网络错误',
              type: 'error',
              duration: 2000,
            })
          }

        }
        // 若不是正确的返回code，且已经登录，就抛出错误
        // const err = new Error(data.description)

        // err.data = data
        // err.response = response

        // throw err

        return data

      },
      err => {
        let temp = err.response && err.response.request && err.response.request.response ? err.response.request.response : "{}"
        let temp1 = JSON.parse(temp) || {}
        temp1.code = Number(temp1.code)
        if (options.loading) {
          hideLoading()
        }
        if (temp1.code === 401) {
          store.dispatch('user/logout')
        }
        if (temp1.code === 500 && temp1.msg.includes('重新登陆')) {
          store.dispatch('user/logout')
        }
        if (!options.hideMsg) {
          Message({
            message: temp1.message || temp1.msg || '网络错误',
            type: 'error',
            duration: 2000,
          })
        }

        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break

            case 401:
              err.message = '未授权，请登录'
              break

            case 403:
              err.message = '拒绝访问'
              break

            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`
              break

            case 408:
              err.message = '请求超时'
              break

            case 500:
              err.message = '服务器内部错误'
              break

            case 501:
              err.message = '服务未实现'
              break

            case 502:
              err.message = '网关错误'
              break

            case 503:
              err.message = '服务不可用'
              break

            case 504:
              err.message = '网关超时'
              break

            case 505:
              err.message = 'HTTP版本不受支持'
              break

            default:
          }
        }
        return temp1 // 返回接口返回的错误信息
      }
    )

    // 请求处理
    instance(options)
      .then((res) => {
        store._mutations['user/SET_HTTPSTATUS'][0](false)
        resolve(res)
        return false
      })
      .catch((error) => {
        store._mutations['user/SET_HTTPSTATUS'][0](false)
        reject(error)
      })
  })
}
